import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import { EntityItem, EntityType } from "../../common-types/Entity";
import styles from "./EntityListItem.module.css";
import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ListItemText from "@mui/material/ListItemText";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";

interface EntityListItemProps extends EntityItem {
  onClick?: (id: string, type: EntityType) => void;
}

const EntityListItem: React.FC<EntityListItemProps> = ({
  id,
  name,
  type,
  onClick,
  description,
}: EntityListItemProps) => {
  const icons: Record<string, React.ElementType> = {
    person: PersonOutlineOutlinedIcon,
    country: OutlinedFlagIcon,
    organization: CorporateFareIcon,
    event: ArticleOutlinedIcon,
  };

  const Icon = icons[type];

  return (
    <ListItem
      onClick={() => onClick?.(id, type)}
      className={styles["container"]}
      component="li"
    >
      <ListItemAvatar>
        <Avatar className={styles["avatar"]}>
          <Icon className={styles["icon"]} />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={name}
        secondary={description}
        secondaryTypographyProps={{ component: "div" }}
        className={styles["item-text"]}
      />
    </ListItem>
  );
};

export default EntityListItem;
